import React from 'react';
import SharedBanner from '../../Shared/SharedBanner/SharedBanner';
import image from '../../../Assets/Backgrounds/pricingBg.webp';
const Banner=()=>{
    return(
        <>
        <SharedBanner 
        backgroundImage={image}
        styles="largeBanner"
        title="Supercharge your design productivity"
        desc="You can use HostDesign unlimited for free,
        and if you want you can support us with coffee and help us make HostDesign even better product."
        />
        </>
    )
};
export default Banner ;